import React from 'react';
import { List, Divider } from '@mui/material';
import NoAlertsDisplay from 'src/layouts/DashboardLayout/TopBar/AlertsComponents/NoAlertsDisplay';
import AlertListItem from 'src/layouts/DashboardLayout/TopBar/AlertsComponents/AlertListItem';

const AlertsContainer = ({ alerts, clickHandler, actionsComponent }) => {
  return (
    <>
      {alerts.length > 0 ? (
        <List
          sx={{
            '& a': {
              color: 'text.secondary',
            },
          }}
        >
          {alerts.map((alert) => (
            <>
              <AlertListItem
                key={`${alert.id}+${alert.message}`}
                alert={alert}
                actionsComponent={actionsComponent}
                clickHandler={clickHandler}
              />
              <Divider component="li" />
            </>
          ))}
        </List>
      ) : (
        <NoAlertsDisplay />
      )}
    </>
  );
};

export default AlertsContainer;
